<div [formGroup]="form">
    <mat-form-field appearance="fill" class="w-full">
        <mat-label>Valores por defecto</mat-label>
        <mat-select formControlName="defaultValue" [compareWith]="compareFn" [multiple]="isMultiple" (selectionChange)="onSelectionChange()">
            <mat-select-trigger>
                {{ displayValue }}
            </mat-select-trigger>
            <mat-option>
                <ngx-mat-select-search [formControl]="searchGeneralCtrl" placeholderLabel="Buscar ..."
                    noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let item of generalList" [value]="item._id">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(item) as code">{{ code }}</b>
                    </div>
                    {{ item.name }}
                </div>
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>